// CSS Modules - component class name prefix: SalesContainer__

<template>
  <div :class="$style.container">
    <div :class="$style.upper">
      <div v-if="config.title" :class="$style.textContainer">
        <i :class="config.icon"></i>
        <span :class="$style.title">{{ config.title }}</span>
      </div>
      <div v-if="config.text" :class="$style.text">{{ config.text }}</div>
      <form
        v-if="
          config.input || config.dropdown || config.worldwide || config.jobs
        "
        @submit.prevent="handleSubmit"
        method="GET"
      >
        <div :class="$style.inputContainer">
          <template v-if="config.input">
            <input
              :class="$style.inputField"
              type="text"
              v-model="inputField"
              :placeholder="config.input.placeholderText"
            />
            <label @click="handleSubmit" :class="$style.button">
              <input
                type="submit"
                title="Suchen"
                value=""
                :class="$style.submitButton"
              />
              <i class="fas fa-search"></i>
            </label>
          </template>
          <Select
            v-else-if="config.dropdown"
            colour="white"
            :selectOptions="config.dropdown.dropdownValues"
            selectValue=""
            trackBy="name"
            label="name"
            :placeholder="config.dropdown.dropdownPlaceholder"
            style="width: 100%; max-width: 25rem;"
            @onChange="handleSelectSubmit"
          />
          <Select
            v-else-if="config.jobs"
            colour="white"
            :selectOptions="regionSelectOptions"
            selectValue=""
            :placeholder="config.jobs.dropdownPlaceholder"
            style="width: 100%; max-width: 25rem;"
            @onChange="handleRegionSelect"
          />
          <Select
            :key="`countryKey-${componentKey}`"
            :class="$style.secondSelect"
            v-if="config.jobs"
            colour="white"
            :selectOptions="companySelectOptions"
            selectValue=""
            :placeholder="config.jobs.dropdownPlaceholderB"
            style="width: 100%; max-width: 25rem;"
            :style="{ visibility: showDropdownTwo ? 'visible' : 'hidden' }"
            @onChange="handleCountrySelect"
          />
          <Select
            v-else-if="config.worldwide"
            colour="white"
            :selectOptions="regionSelectOptions"
            selectValue=""
            :placeholder="config.worldwide.dropdownPlaceholder"
            style="width: 100%; max-width: 25rem;"
            @onChange="handleRegionSelect"
          />
          <Select
            :key="`countryKey-${componentKey}`"
            :class="$style.secondSelect"
            v-if="config.worldwide && showDropdownTwo"
            colour="white"
            :selectOptions="countrySelectOptions"
            selectValue=""
            :placeholder="config.worldwide.dropdownPlaceholder"
            style="width: 100%; max-width: 25rem;"
            @onChange="handleCountrySelect"
          />
        </div>
      </form>
      <template v-if="config.static">
        <p :class="$style.staticText">{{ config.static.phone }}</p>
        <p :class="$style.staticText">
          <a :href="mailtoLink">{{ config.static.email }}</a>
        </p>
      </template>
    </div>
    <div v-if="config.buttons" :class="$style.lower">
      <template v-for="(button, index) in config.buttons">
        <a
          v-if="button.linkUrl"
          :class="$style.link"
          :href="button.linkUrl"
          :key="index"
        >
          <div :class="$style.imageContainer">
            <i :class="button.icon"></i>
          </div>
          <div :class="$style.linkText">{{ button.text }}</div>
        </a>
        <div v-else @click="startChat" :class="$style.link" :key="index">
          <div :class="$style.imageContainer">
            <i :class="button.icon"></i>
          </div>
          <div :class="$style.linkText">
            {{ isChatActive ? button.text : button.offlineText }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Select from "../Select/Select";
import { regionDataUrl } from "../../shared/globals";

export default {
  name: "SalesContainer",
  components: {
    Select
  },
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      componentKey: 0,
      apiData: null,
      inputField: "",
      dropdownOneValue: "",
      showDropdownTwo: false,
      regionSelectOptions: [],
      countrySelectOptions: [],
      companySelectOptions: [],
      isChatActive: false
    };
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    handleSubmit(e) {
      e.preventDefault();
      window.location = `${this.config.input.submitUrl}${this.inputField}`;
    },
    handleSelectSubmit(value) {
      if (value.submitUrl) {
        window.location = value.submitUrl;
      }
    },
    handleRegionSelect(value) {
      if (value !== "") {
        this.companySelectOptions = [];
        this.dropdownOneValue = value;
        this.showDropdownTwo = true;

        if (this.config.jobs) {
          const targetgroups = [];
          for (let region of this.apiData.items) {
            if (
              region.filterCategories.country === this.dropdownOneValue ||
              value === this.config.resetSelectOption
            ) {
              for (let targetgroup of region.filterCategories.targetgroup) {
                targetgroups.push(targetgroup);
              }
            }
          }
          this.companySelectOptions.push(this.config.resetSelectOption);
          this.companySelectOptions.push(
            ...this.filterUniqueObjects(targetgroups)
          );
        } else if (this.apiData.regions) {
          for (let region of this.apiData.regions) {
            if (region.name === this.dropdownOneValue) {
              for (let country of region.countries) {
                this.countrySelectOptions.push(country.name);
              }
            }
          }
        }
        this.forceRerender();
      }
    },
    handleCountrySelect(value) {
      if (this.config.worldwide) {
        window.location = `${this.config.worldwide.submitUrl}&cnEntry=${
          this.dropdownOneValue
        }&country=${value}`;
      }
      if (this.config.jobs) {
        window.location = `${
          this.config.jobs.submitUrl
        }?selectedCategory=${value}&selectedCountry=${this.dropdownOneValue}`;
      }
    },
    startChat() {
      if (
        window.LC_API &&
        window.LC_API.is_loaded() &&
        window.LC_API.open_chat_window
      ) {
        window.LC_API.open_chat_window();
        return false;
      }
    },
    filterUniqueObjects(data) {
      return data.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    },
    initApiData(data) {
      if (this.config.jobs) {
        const countries = [];
        this.apiData = data;
        for (let region of this.apiData.items) {
          countries.push(region.filterCategories.country);
        }
        this.regionSelectOptions.push(this.config.resetSelectOption);
        this.regionSelectOptions.push(...this.filterUniqueObjects(countries));
      } else if (data.regions) {
        this.apiData = data;
        for (let region of this.apiData.regions) {
          this.regionSelectOptions.push(region.name);
        }
      }
    },
    checkLCAgentsAvailability() {
      if (window.LC_API && window.LC_API.agents_are_available) {
        this.isChatActive = window.LC_API.agents_are_available();
        window.removeEventListener(
          "livechatReady",
          this.checkLCAgentsAvailability
        );
      } else {
        window.addEventListener(
          "livechatReady",
          this.checkLCAgentsAvailability
        );
      }
    }
  },
  computed: {
    mailtoLink: function() {
      if (this.config.static) {
        return `mailto:${this.config.static.email}`;
      }
      return "";
    }
  },
  mounted() {
    let dataUrl = "";
    if (this.config.worldwide) {
      window.regionDataUrl
        ? (dataUrl = window.regionDataUrl)
        : (dataUrl = regionDataUrl);
    } else if (this.config.jobs) {
      dataUrl = this.config.jobs.jsonUrl;
    }
    axios
      .get(dataUrl)
      .then(response => this.initApiData(response.data))
      .catch(error => console.error(error));

    this.checkLCAgentsAvailability();
  }
};
</script>

<style module lang="scss">
@import "./SalesContainer.scss";
</style>
